import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRecentCallins extends Layout {
    sourceCallin: DataSource;
    tableCallins: Table;
}
